import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { LorenzControlTypeEnum } from '../../enums/lorenz-control-type.enum';
import { LibFormControlTextComponent } from '../../controls/text/lib-form-control-text.component';
import { LibFormControlDatetimeComponent } from '../../controls/datetime/lib-form-control-datetime.component';
import { LibFormControlObjectComponent } from '../../controls/object/lib-form-control-object.component';
import { LibFormControlCheckboxComponent } from '../../controls/checkbox/lib-form-control-checkbox.component';
import { LibFormControlRadioComponent } from '../../controls/radio/lib-form-control-radio.component';
import { LibFormControlSelectComponent } from '../../controls/select/lib-form-control-select.component';
import { LibFormControlTextareaComponent } from '../../controls/textarea/lib-form-control-textarea.component';
import { LorenzFormComponentDisplayOptions } from '../../interfaces/lorenz-form-component-options.interface';
import { LorenzFormControl } from '../../lorenz-form-control';
import { NgTemplateOutlet } from '@angular/common';
import { LibFormControlHtmlComponent } from '../../controls/html/lib-form-control-html.component';
import { LibFormImagePasteComponent } from '../../controls/image-paste/lib-form-image-paste.component';
import { LibFormControlDocumentUploadComponent } from '../../controls/document-upload/lib-form-control-document-upload.component';

@Component({
	selector: 'lib-form-component-control',
	// prettier-ignore
	imports: [
		LibFormControlCheckboxComponent,
		LibFormControlDatetimeComponent,
		LibFormControlDocumentUploadComponent,
		LibFormControlHtmlComponent,
		LibFormControlObjectComponent,
		LibFormControlRadioComponent,
		LibFormControlSelectComponent,
		LibFormControlTextComponent,
		LibFormControlTextareaComponent,
		LibFormImagePasteComponent,
		NgTemplateOutlet
	],
	templateUrl: './lorenz-form-control.component.html',
	styleUrl: './lorenz-form-control.component.scss'
})
export class LorenzFormControlComponent implements OnInit {
	protected readonly LorenzControlTypeEnum = LorenzControlTypeEnum;

	@Input({ required: false, alias: 'control' }) lorenzFormControl: LorenzFormControl | null = null;

	@Input({ required: false, alias: 'options' }) lorenzFormComponentOptions: LorenzFormComponentDisplayOptions = {};

	@HostBinding('attr.id') id: string | null = null;

	@HostBinding('attr.class') hostCssClass: string | null = null;

	public ngOnInit(): void {
		if (this.lorenzFormControl) {
			this.id = this.lorenzFormControl.getFullKey();
			// prettier-ignore
			this.hostCssClass = [
				this.lorenzFormComponentOptions?.layout ?? this.lorenzFormControl.getLayout(),
				this.lorenzFormControl.getKey(),
				this.lorenzFormControl.getDirection() === 'row' ? 'row' : '',
				this.lorenzFormControl.getLabel() ? '' : 'no-label'
			].join(' ').trim();
		}
	}
}
